/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { FormattedMessage } from '@modules/i18n'
import type { Subscription } from '@modules/cloud-api/v1/types'
import { CuiTable } from '@modules/cui/Table'
import type { CuiTableColumn } from '@modules/cui/Table'

import type { FunctionComponent } from 'react'

interface Props {
  prepaidSubscriptions: Subscription[] | undefined
  initialLoading: boolean
}

const OrganizationPrepaidSubscriptionsTable: FunctionComponent<Props> = ({
  prepaidSubscriptions,
  initialLoading,
}) => {
  const columns: Array<CuiTableColumn<Subscription>> = [
    {
      label: (
        <FormattedMessage id='organization.organization-prepaids-table.id' defaultMessage='ID' />
      ),
      render: ({ subscription_id }) => subscription_id,
    },
    {
      label: (
        <FormattedMessage
          id='organization.organization-prepaids-table.type'
          defaultMessage='Type'
        />
      ),
      render: ({ subscription_type }) => subscription_type,
    },
    {
      label: (
        <FormattedMessage
          id='organization.organization-prepaids-table.range'
          defaultMessage='Range'
        />
      ),
      render: ({ subscription_range: { start, end } }) => `${start} - ${end}`,
    },
    {
      label: (
        <FormattedMessage
          id='organization.organization-prepaids-table.created'
          defaultMessage='Created'
        />
      ),
      render: ({ created }) => created,
    },
    {
      label: (
        <FormattedMessage
          id='organization.organization-prepaids-table.last-modified'
          defaultMessage='Last modified'
        />
      ),
      render: ({ last_modified }) => last_modified,
    },
    {
      label: (
        <FormattedMessage
          id='organization.organization-prepaids-table.data'
          defaultMessage='Data'
        />
      ),
      render: ({ data }) => JSON.stringify(data),
    },
  ]

  return (
    <CuiTable<Subscription>
      rows={prepaidSubscriptions}
      columns={columns}
      initialLoading={initialLoading}
    />
  )
}

export default OrganizationPrepaidSubscriptionsTable
